/**
 * Get browser metadata for form submissions.
 * @returns {Object} Browser data object with href and referrer
 */
const getBrowserData = () => {
    return {
        current_href: location.href,
        referrer: document.referrer
    };
};

export default getBrowserData;
